'use client';

import React from 'react'
import Image from 'next/image';
import { usePathname } from 'next/navigation';

// Assets
import Century21 from '@public/png/century-21-black-1.png';
import One21 from '@public/png/one21.png';
import ArrowUpRight from '@public/png/arrow-up-right-1.png';
import useRedirect from '@src/hooks/useRedirect';

import useWhatsappMessage from '@src/hooks/useWhatsapp';

const SocialMedia = ({ label, ...props }) => <a {...props} className="cursor-pointer text-13 underline font-sfpro-heavy mr-4 last:mr-0 
dd-sm:mb-6 dd-sm:mb-0">{label}</a>

const Footer = () => {
  const pathname = usePathname()
  const isHomepage = pathname === "/";
  const { sendMessage } = useWhatsappMessage();

  const handleSendMessage = (type = "button") => {
    if (type === "anchor") {
      return sendMessage({
        phone: "6285692588739",
        type,
        message: "Hi Century 21 Indonesia"
      })
    }

    sendMessage({
      phone: "6285692588739",
      type,
      message: "Hi Century 21 Indonesia"
    })
  }
  
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  const redirect = useRedirect();
  const handleToHomepage = () => {
    redirect("/")
  }

  return (
    <div className={`main-wrapper pt-[40px] ${isHomepage ? "bg-white-3" : "bg-white-4"}`}>
      <div className='content-wrapper mb-4 
      dd-lg:mb-0'>
        <div className='flex justify-between items-start mb-6 
        dd-xl:flex-col-reverse dd-xl:items-center dd-xl:justify-center 
        dd-lg:items-start dd-lg:mb-[56px]'>
          <div className='dd-xl:flex dd-xl:flex-col dd-xl:items-center 
          dd-xl:mb-[104px] 
          dd-lg:mb-0'>
            <p className='w-[568px] text-17 text-black-1 mb-[32px] 
            dd-xl:text-center 
            dd-lg:text-start dd-lg:w-full'>Dapatkan keuntungan dari kemitraan kami yang kokoh dan andal. Kami bangga bermitra dengan perusahaan terkemuka untuk memberikan layanan terbaik
              kepada Anda.</p>

            <button onClick={handleSendMessage} className='px-[18px] py-[14px] rounded-[80px] border border-solid border-black-1 
            text-15 font-sfpro-heavy 
            hover:bg-black-1 hover:text-white-3
            dd-lg:w-full'>HUBUNGI KAMI SEKARANG</button>
          </div>
          <div className='dd-xl:mb-[40px] dd-xl:flex dd-xl:flex-col dd-xl:items-center
          dd-lg:items-start'>
            <div className='cursor-pointer flex items-end mb-4 
            dd-lg:items-center' onClick={handleToHomepage}>
              <Image
                width="auto"
                height="auto"
                src={Century21}
                className='w-[214.26px] h-6 object-contain mr-[12px] 
                dd-2xl:w-[142px] dd-2xl:h-4 
                dd-xl:w-[214.26px] dd-xl:h-6 
                dd-lg:w-[130px]'
                alt='CENTURY 21'
              />
              <p className='capitalize text-[20px] text-black-3 font-typold-extended-medium leading-[89%] tracking-[0.16px] 
                dd-2xl:text-[12px]'>Indonesia</p>
            </div>
            <div className='flex'>
              <p className='text-13 text-grey-1 mr-1'>Powered by</p>
              <Image
                src={One21}
                alt='One21'
                width="auto"
                height="auto"
                className='object-contain w-[69px] h-[16px]'
              />
            </div>
          </div>
        </div>

        <div className='flex justify-between items-end 
        dd-lg:flex-col-reverse dd-lg:items-start'>
          <div className='flex items-end'>
            <p className='mr-2 text-13 text-black-1'>KEMBALI KE ATAS</p>
            <button onClick={handleScrollToTop} className='cursor-pointer p-0.5 border border-solid border-black-1 w-[20px] h-[20px] flex items-center justify-center rounded-[80px]'>
              <Image
                src={ArrowUpRight}
                alt='Arrow Up Right'
                width={16}
                height={16}
                className='object-fit'
              />
            </button>
          </div>

          <div className='flex items-end 
          dd-lg:mb-6 
          dd-sm:flex-col dd-sm:items-start dd-sm:justify-start dd-sm:mb-0'>
            <SocialMedia label="INSTAGRAM" href="https://www.instagram.com/century21indonesia?igsh=bms1MzVzZTV3cXNi" />
            <SocialMedia label="FACEBOOK" href="https://www.facebook.com/century21indonesia" />
            <SocialMedia label="YOUTUBE" href="https://www.youtube.com/@century21indonesia" />
            <SocialMedia label="WHATSAPP" href={handleSendMessage("anchor")} />
          </div>
        </div>
      </div>

      <div className='w-full h-[1px] border border-solid border-grey-0 my-6' />

      <div className='content-wrapper mb-6'>
        <div className='flex items-center justify-between 
        dd-lg:block'>
          <p className='text-13 text-black-1 
          dd-lg:mb-2'>Designed by CENTURY 21 Indonesia</p>
          <p className='text-13 text-black-1'>{"©"} 2024 CENTURY 21 Indonesia. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default Footer